import { Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import { SearchInput } from "components/Atoms/SearchInput";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import React, { useEffect } from "react";
import { useDebounce } from "utilities/usehooks";
import { containsAnyMergefields, getFilteredMergetopics, getSelectionCountByTopic } from "../../../exceltemplate/ColumnsPanel/utils";
import MergeTopicColumn from "./MergeTopic";

interface Props {
  columns: server.dto.ExcelTemplateColumn[]
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  isOpen: boolean
  onClose: (newMergeFields: string[]) => void
}

const AddColumnsModal = (props: Props) => {
  const [selectedMergeFields, setSelectedMergeFields] = React.useState(props.columns.map(c => c.mergeField));
  const selectedMergeFieldsSet = new Set(selectedMergeFields);
  const selectedMergeFieldsByTopic = getSelectionCountByTopic(props.availableMergeFieldTopics, selectedMergeFieldsSet);

  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery);

  useEffect(() => {
    setSelectedMergeFields(props.columns.map(c => c.mergeField));
  }, [props.columns]);

  const onMergeFieldChanged = (mergeField: string, checked: boolean) => {
    if (checked) {
      setSelectedMergeFields([...selectedMergeFields, mergeField]);
    } else {
      setSelectedMergeFields(selectedMergeFields.filter(mf => mf !== mergeField));
    }
  }

  const filteredMergeTopics = getFilteredMergetopics(props.availableMergeFieldTopics, debouncedSearchQuery)
    .filter(topic => containsAnyMergefields(topic));
  const hasResults = filteredMergeTopics.length > 0;

  const onClose = () => {
    props.onClose(selectedMergeFields);
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Template.SelectColumns}
    width="large"
    height={1200}
    handleClose={() => props.onClose(props.columns.map(c => c.mergeField))}>
    <SearchInput
      onChange={value => { setSearchQuery(value); }}
      value={searchQuery}
      placeholder={RESX.GeneralLabels.Search}
      focusOnMount
    />
    <div className="grow1 scrollbox-auto margin-bottom">
      <div className="flex-column gap">
        {!hasResults && <NoDataAvailableDiv />}
        {hasResults && filteredMergeTopics.map((mergeTopic) => (
          <MergeTopicColumn
            key={mergeTopic.label}
            selectedCount={selectedMergeFieldsByTopic[mergeTopic.label] || 0}
            mergeTopic={mergeTopic}
            selectedMergeFieldsSet={selectedMergeFieldsSet}
            onMergefieldChanged={onMergeFieldChanged}
          />
        ))}
      </div>
    </div>

    <div className="flex justify-end">
      <ButtonPrimary
        label={RESX.Buttons.btnSave}
        onClick={onClose}
      />
    </div>
  </Modal>;
}

export default AddColumnsModal;